import FileAutocomplete from './FileTypeAutocomplete';

export default FileAutocomplete;
